// extracted by mini-css-extract-plugin
export default {"advertFooter":"apObtey2"};